import { Component, OnInit, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { ParserService } from 'src/app/component/broker-parser/planner-service/parser-service';
import { BrokerService } from 'src/app/service/broker-service/broker.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-compliance-notifications',
  templateUrl: './compliance-notifications.component.html',
  styleUrls: ['./compliance-notifications.component.css']
})
export class ComplianceNotificationsComponent implements OnInit, OnDestroy {
  search = '';
  user: any;
  timeZone: string;
  dateRange: any[] = [];
  notifications: any[] = [];
  filteredNotifications: any[] = [];
  cachedAuthData: any = null;
  isLoading: boolean = false;

  constructor(
    private sharedDataService: SharedDataService,
    private parserService: ParserService,
    private brokerService: BrokerService
  ) { }

  ngOnInit() {
    this.getUser();
  }

  async getAuthData() {
    if (this.cachedAuthData) {
      return this.cachedAuthData;
    }

    const allSettings = await this.parserService.getBrokerSettingList().toPromise();
    if (allSettings && allSettings.length) {
      const settings = allSettings.find(function (broker:any) {
        return broker.name === 'awmt' || (broker.name && broker.name.toLowerCase() === 'awmt');
      });
      if (settings) {
        const username = settings.username;
        const password = settings.password;
        const payload = {
          email: username,
          password: password,
          role: 'company'
        };
        return await this.getBrokerToken(payload);
      }
    }
    return null;
  }

  async getBrokerToken(payload: any) {
    let authData: any = { accessToken: '', companyId: '' };
    const response = await this.brokerService.getToken(payload).toPromise();
    if (response) {
      const tokens = response.tokens;
      const user = response.user;
      if (tokens && tokens.access && tokens.access.token) {
        authData.accessToken = tokens.access.token;
        if (user && user.company && user.company.id) {
          authData.companyId = user.company.id;
        }
        this.cachedAuthData = authData;
      } else {
        console.log('broker communication error');
      }
    }
    return authData;
  }

  async getComplianceNotifications() {
    this.isLoading = true;
    try {
      const authData = await this.getAuthData();
      if (authData && authData.accessToken) {
        const token = authData.accessToken;
        const queryParams: any = {
          limit: 9999,
          time : [this.dateRange[0], this.dateRange[1]]
        };
        // if (this.dateRange && this.dateRange.length === 2 && this.dateRange[0] && this.dateRange[1]) {
        //   queryParams.time = [this.dateRange[0], this.dateRange[1]];
        // }
        const res = await this.brokerService.getNotifications(token, queryParams).toPromise();
        this.notifications = res.results;
        this.filteredNotifications = this.notifications.filter(function (notification) {
          return notification.type === 'documents';
        });
      } else {
        this.notifications = [];
        this.filteredNotifications = [];
      }
    } catch (err) {
      console.error('Error fetching compliance notifications:', err);
      this.notifications = [];
      this.filteredNotifications = [];
    } finally {
      this.isLoading = false;
    }
  }

  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.user = data;
          this.timeZone = this.user.timeZone;
          if (this.timeZone) {
            this.dateRange = [
              moment.tz(this.timeZone).startOf('day').toISOString(),
              moment.tz(this.timeZone).endOf('day').toISOString()
            ];
          } else {
            this.dateRange = [
              moment().startOf('day').toISOString(),
              moment().endOf('day').toISOString()
            ];
          }
          this.getComplianceNotifications();
        }
      });
  }

  onDateChange(event: any) {
    if (event && event[0] && event[1]) {
      if (this.timeZone) {
        this.dateRange = [
          moment(event[0]).tz(this.timeZone).startOf('day').toISOString(),
          moment(event[1]).tz(this.timeZone).endOf('day').toISOString()
        ];
      } else {
        this.dateRange = [
          moment(event[0]).startOf('day').toISOString(),
          moment(event[1]).endOf('day').toISOString()
        ];
      }
      this.getComplianceNotifications();
    }
  }

  ngOnDestroy(): void { }
}
